import { SelectOption } from '../model/select.option';
import * as moment from 'moment';

export enum calendarTimezone {
    greenwich = 'Etc/Greenwich',
    newYork = 'America/New_York',
}

export namespace calendarTimezone {
    export function toIterable(): Array<string> {
        return Object.keys(calendarTimezone).filter(key => typeof calendarTimezone[key] !== 'function');
    }

    /**
     * Rótulos das duas opções especiais. Vêm JÁ TRADUZIDOS do consumidor
     * (`translate.instant`) porque o texto é composto — "America/Sao_Paulo
     * (Fuso horário do evento)" — e o `| translate` do seletor só resolve
     * chaves inteiras, não trechos. Sem eles, cai no inglês histórico.
     */
    export interface TimeZoneLabels {
        event?: string;
        browser?: string;
    }

    export function toSelectable(eventTimeZone: string | undefined, browserTimeZone: string,
                                 labels?: TimeZoneLabels): Array<SelectOption> {
        const eventLabel = (labels && labels.event) || `Event's Time Zone`;
        const browserLabel = (labels && labels.browser) || `Browser's Time Zone`;
        const timezones = calendarTimezone.toIterable().map(value => ({
            id: value,
            value: calendarTimezone[value],
            offset: moment.tz(calendarTimezone[value]).utcOffset()
        }));

        if (browserTimeZone != eventTimeZone) {
            timezones.unshift({id: 'browser', value: `${browserTimeZone} (${browserLabel})`, offset: moment.tz(browserTimeZone).utcOffset()});
        }
        if (!!eventTimeZone) {
            timezones.unshift({id: 'event', value: `${eventTimeZone} (${eventLabel})`, offset: moment.tz(eventTimeZone).utcOffset()});
        }

        return timezones;
    }
}
